<script setup lang="ts">
import CarouselMobile from '../../../CarouselMobile/CarouselMobile.vue';
import IMG_CUSTOM_FRAME from '../../assets/custom-background.png';

interface Props {
  backgroundImage: string;
}

defineProps<Props>();
</script>

<template>
<div class="custom">
  <CarouselMobile
    :mobileFrameImage="IMG_CUSTOM_FRAME"
    :backgroundImage="backgroundImage"
  />
</div>
</template>
